import { render, staticRenderFns } from "./extrato-regularidade-fiscal.vue?vue&type=template&id=559a2e24&scoped=true"
import script from "./extrato-regularidade-fiscal.vue?vue&type=script&lang=js"
export * from "./extrato-regularidade-fiscal.vue?vue&type=script&lang=js"
import style0 from "./extrato-regularidade-fiscal.vue?vue&type=style&index=0&id=559a2e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559a2e24",
  null
  
)

export default component.exports